import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContactModel, ResultBulkAddModel } from '@models/index';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactsService {
  constructor(
    private http: HttpClient
  ) { }

  searchContactsByLocation(payload: { page: number, size: number, locationId: string }): Observable<{ data: ContactModel[], total: number }> {
    return this.http
      .get(`${environment.apiPath}/contacts?page=${payload.page}&size=${payload.size}&locationId=${payload.locationId}`)
      .pipe(
        map((items: { data: ContactModel[], total: number }) => ({
          data: items.data,
          total: items.total
        }))
      )
  }

  searchContactsByQueryByLocation(payload: { page: number, size: number, query: string, locationId: string }): Observable<{ data: ContactModel[], total: number }> {
    return this.http
      .get(`${environment.apiPath}/contacts/autocomplete?page=${payload.page}&size=${payload.size}&locationId=${payload.locationId}&query=${payload.query}`)
      .pipe(
        map((items: { data: ContactModel[], total: number }) => ({
          data: items.data,
          total: items.total
        }))
      )
  }

  searchContactsByBusiness(payload: { page: number, size: number, businessId: string }): Observable<{ data: ContactModel[], total: number }> {
    return this.http
      .get(`${environment.apiPath}/contacts/business?page=${payload.page}&size=${payload.size}&id=${payload.businessId}`)
      .pipe(
        map((items: { data: ContactModel[], total: number }) => ({
          data: items.data,
          total: items.total
        }))
      )
  }

  searchContactsByQueryByBusiness(payload: { page: number, size: number, query: string, businessId: string }): Observable<{ data: ContactModel[], total: number }> {
    return this.http
      .get(`${environment.apiPath}/contacts/business/autocomplete?page=${payload.page}&size=${payload.size}&id=${payload.businessId}&query=${payload.query}`)
      . pipe(
        map((items: { data: ContactModel[], total: number }) => ({
          data: items.data,
          total: items.total
        }))
      )
  }

  createContact(payload: {contact : ContactModel, campaignId:string}): Observable<{ message: string, status: string, data: ContactModel }> {
    return this.http
      .post(`${environment.apiPath}/contacts/create`, payload)
      .pipe(
        map((data: { message: string, status: string, data: ContactModel }) => data)
      );
  }

  bulkAddContacts(payload: {contact : ContactModel, campaignId:string}[]): Observable<ResultBulkAddModel> {
    return this.http
      .post<ResultBulkAddModel>(`${environment.apiPath}/contacts/contacts`, payload)
  }

  editContact(payload: {contact : ContactModel, campaignId:string}): Observable<ContactModel> {
    return this.http
      .post(`${environment.apiPath}/contacts/update?locationId=${payload.contact.locationId}`, payload)
      .pipe(
        map(data => data as ContactModel)
      );
  }

  deleteContact(payload: { contactId: string, locationId: string }): Observable<string> {
    return this.http
      .post(`${environment.apiPath}/contacts/${payload.locationId}/${payload.contactId}`, null)
      .pipe(
        map((data: { data: string }) => data.data as string)
      );
  }
}
